// -- Endpoints --

// WP POSTS
export const WP_GET_POSTS = 'posts';

// WP PAGES
export const WP_GET_PAGES = 'pages';

// CATEGORIES
export const WP_GET_CATEGORIES = 'categories';

export const WP_GET_USER = 'users';
